import React from 'react';
import Modal from './Modal';

interface Props {
  title?: string;
  titleUnderline?: boolean;
  visible: boolean;
  close?: () => void;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  customClass?: string;
}

const CustomModal = (props: Props) => {
  const { title, titleUnderline, children, visible, setVisible, close, customClass } = props;

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      close={close}
      title={title}
      titleUnderline={titleUnderline}
      customClass={customClass}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
